import React,{useState} from "react";
import { Link } from "react-router-dom";
import about2 from "../assets/images/about2.jpg"
import about from "../assets/images/about.jpg"
import ModalVideo from 'react-modal-video';
import "../../node_modules/react-modal-video/css/modal-video.css"

export default function About(){
    const [isOpen, setOpen] = useState(false);
    return(
        <>
        <div className="container relative md:pb-24 pb-16">
                <div className="grid md:grid-cols-12 grid-cols-1 items-center gap-6">
                    <div className="lg:col-span-5 md:col-span-6">
                        <div className="relative">
                            <div className="relative flex justify-start">
                                <img src={about} className="lg:w-[400px] w-[280px] rounded-xl shadow dark:shadow-gray-700" alt=""/>
                               
                               
                            </div>
                           
                        </div>
                    </div>

                    <div className="lg:col-span-7 md:col-span-6">
                        <div className="lg:ms-5">
                            <h6 className="text-orange-500 text-sm font-medium uppercase mb-2">About</h6>
                            <h3 className="mb-4 md:text-2xl text-xl font-medium">Gohar's Experience</h3>

                            <p className="text-slate-400 dark:text-white/60 max-w-xl text-align-justify">
                            I am a Full-Stack Developer with over <b>6 years</b> of experience in creating websites and mobile applications. I specialize in using technologies like Laravel, React JS & Native, Expo, Java, and Firebase to build both the front-end and back-end of projects.
                            <br/><br/>Additionally, I am a <b>React Native</b> developer, specializing in the creation of hybrid mobile applications and their successful publication in the respective app stores.
                            I am deeply involved in every stage of the development process, from planning and system architecture to deployment and maintenance.
I also have expertise in <b>UI/UX</b> design, which allows me to create user-friendly interfaces and enhance the overall user experience. Throughout my career, I have successfully worked on competitive projects, helping teams tackle challenging ideas and turn them into successful applications. I take pride in making efficient solutions that meet client needs.
<br/><br/>
I have experience working on crash projects, assisting teams with backend architecture, database business logics, payment integration issues, third party modules integration and resolving push notification issues. My skills in programming with <b>PHP</b>, React and JavaScript enable me to solve problems effectively. I enjoy collaborating with teams and believe in clear communication to ensure projects run smoothly.
<br/><br/>
I possess advanced expertise in custom application development, but I am committed to continuous learning and professional growth.  I am passionate about translating business goals into seamless digital solutions and am always eager to explore new technologies to stay ahead and drive innovation       x.
<br/><br/>
Let’s connect and see how I can help you with your projects!
                            </p>

                        </div>
                    </div>
                </div>
                <div>
                    <div className="container relative mt-16">
                        <div className="grid  sm:grid-cols-4 grid-cols-2 justify-center gap-6">
                           
                            <div className="w-100 bg-white dark:bg-slate-900 shadow dark:shadow-gray-700 text-center rounded-xl mx-auto py-6">
                                <span className="text-2xl">😊 50+</span>
                                <h1 className="mt-2">Happy Clients</h1>
                            </div>
                            <div className="w-100 bg-white dark:bg-slate-900 shadow dark:shadow-gray-700 text-center rounded-xl mx-auto py-6">
                                <span className="text-2xl">🏆 6+</span>
                                <h1 className="mt-2">Year Experience</h1>
                            </div>
                            <div className="w-100 bg-white dark:bg-slate-900 shadow dark:shadow-gray-700 text-center rounded-xl mx-auto py-6">
                                <span className="text-2xl">🎉 100+</span>
                                <h1 className="mt-2">Successful Projects</h1>
                            </div>
                            <div className="w-100 bg-white dark:bg-slate-900 shadow dark:shadow-gray-700 text-center rounded-xl mx-auto py-6">
                                <span className="text-2xl">🔥 100%</span>
                                <h1 className="mt-2">Passion</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}